import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPatientVitalThreshold, savePatientThreshold } from "../../api/patientVitalThreshold";

export const getPatientVitalThreshold = createAsyncThunk("careTeam/getPatientVitalThreshold", async (variables, { rejectWithValue }) => {
  try {
    const response = await fetchPatientVitalThreshold(variables);
    return response?.body;
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});

export const savePatientVitalThreshold = createAsyncThunk("careTeam/savePatientVitalThreshold", async (data, { rejectWithValue }) => {
  try {
    const response = await savePatientThreshold(data);
    return JSON.parse(response?.body);
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});


const patientVitalThresholdSlice = createSlice({
  name: "patientVitalThreshold",
  initialState: {
    currentPatientVitalsThresholds: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetState: (state) => {
      state.currentPatientVitalsThresholds = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPatientVitalThreshold.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientVitalThreshold.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPatientVitalsThresholds = action.payload.data;
        state.error = null;
      })
      .addCase(getPatientVitalThreshold.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(savePatientVitalThreshold.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(savePatientVitalThreshold.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(savePatientVitalThreshold.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { resetState } = patientVitalThresholdSlice.actions;
export default patientVitalThresholdSlice.reducer;